import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { ClientAnnouncement } from '@/api/announcements/announcementsApi.types';
import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { AnnouncementItem } from '@/components/client/AnnouncementsPage/AnnouncementItem';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useAnnouncementSenderName } from '@/hooks/useAnnouncementSenderName';

interface LatestAnnouncementsCardProps {
  announcements: ClientAnnouncement[];
  totalAnnouncementsCount: number;
}

export function LatestAnnouncementsCard({
  announcements,
  totalAnnouncementsCount,
}: LatestAnnouncementsCardProps) {
  const { t } = useTranslation('clients');
  const navigate = useNavigate();
  const senderName = useAnnouncementSenderName();

  if (announcements.length === 0) {
    return null;
  }

  return (
    <Card as="section">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name="Megaphone" />
        </span>
        <h2 className="text-sm font-bold text-zooindigo">{t('announcements.title')}</h2>
      </div>
      <div className="divide-y divide-zooborder">
        {announcements.map(function renderAnnouncement(announcement) {
          return (
            <AnnouncementItem
              key={announcement.id}
              announcement={announcement}
              senderName={senderName}
            />
          );
        })}
      </div>
      {totalAnnouncementsCount > announcements.length ? (
        <Button
          variant="outline"
          size="chip"
          className="w-full mt-2"
          onClick={function seeAll() {
            navigate(APPLICATION_ROUTES.clientPortalAnnouncements);
          }}
        >
          {t('announcements.seeAll')}
        </Button>
      ) : null}
    </Card>
  );
}
